import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { usePostApiArbitrageRefuse } from '@/api/arbitrage/arbitrage';
import { Spinner } from '@/components/Spinner/Spinner';
import { ROUTE } from '@/constants/route';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

interface ContentModalDeclineArbitrageProps {
  arbitrageId: string;
  placementId: string;
  onReviewProposal: () => void;
}

const ContentModalDeclineArbitrage = ({
  arbitrageId,
  placementId,
  onReviewProposal,
}: ContentModalDeclineArbitrageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutate, isPending } = usePostApiArbitrageRefuse();

  const onClickConfirmDecline = () => {
    mutate(
      { arbitrageId, data: { placementId } },
      {
        onSuccess: () => {
          navigate({
            pathname: ROUTE.ARBITRAGESIGNATUREREFUSAL,
            search: `?placement=${arbitrageId}`,
          });
        },
      }
    );
  };

  return (
    <div className={styles.modalDeclineContainer}>
      <h2 className={styles.title}>{t('summaryArbitrage.declineModal.title')}</h2>
      <div className={styles.content}>
        <div className={styles.description}>
          <p>{t('summaryArbitrage.declineModal.intro')}</p>
          <p className={styles.secondParagraph}>{t('summaryArbitrage.declineModal.description')}</p>
        </div>
        <div className={styles.buttonAction}>
          <MtxButton
            className={styles.actionBtn}
            variant="tertiary"
            size="large"
            fullWidth
            onClick={() => {
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'placement',
                event_nom: 'revoir_la_proposition',
                event_detail_1: 'popin',
                event_detail_2: 'refuser_la_propositon',
              });
              onReviewProposal();
            }}
          >
            {t('summaryArbitrage.declineModal.reviewProposalButton')}
          </MtxButton>
          <MtxButton
            className={styles.actionBtn}
            variant="secondary"
            size="large"
            fullWidth
            disabled={isPending}
            onClick={() => {
              void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                event_id: 'clic',
                event_categorie: 'clic',
                event_metier: 'placement',
                event_nom: 'confirmer_le_refus',
                event_detail_1: 'popin',
                event_detail_2: 'refuser_la_propositon',
              });
              onClickConfirmDecline();
            }}
          >
            <div className={styles.buttonContent}>
              {isPending && <Spinner diameter={20} />}
              {t('summaryArbitrage.declineModal.confirmDeclineButton')}
            </div>
          </MtxButton>
        </div>
      </div>
    </div>
  );
};

export { ContentModalDeclineArbitrage };
